<div *ngIf="(baseSite$ | async)?.logo as logo; else noLogo" class="logo-container">
  <a [customRouterLink]="'/'">
    <img
      [alt]="logo.altText"
      [defaultImage]="logo.url"
      [errorImage]="'./assets/ui/shared/error/not_found_error_image.png'"
      [lazyLoad]="logo.url"
      [title]="logo.titleText"
      height="85"
      src="#"
      width="140"/>
  </a>
</div>
<ng-template #noLogo>
  <img
    alt="error_image"
    height="85"
    src="./assets/ui/shared/error/not_found_error_image.png"
    title="error_image"
    width="140"/>
</ng-template>
